module.exports = __webpack_public_path__ + "e0488698e45b9e19ff5288463d572e0c.png";